// @flow

import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import TabRouter from '@westfieldcorp/tab-router';
import { WORLD_DATA_EVENTS_COUNTRY, WORLD_EVENTS } from '../../../path/worldPaths';
import eventsApi from '../../../network/api/eventsApi';
import EventTab from './events/EventTab';
import { CountryEventType } from '../../../types/eventType';
import { I18n } from 'react-redux-i18n';

type Props = {
  history: any,
}

type State = {
  tabs: [{
    link: string,
    label: string,
  }],
}

class EventPage extends React.PureComponent<Props, State> {
  state = {
    tabs: [],
  };

  fetchTabsCountry = () => {
    eventsApi.listCountryTab()
      .then(resp => resp.json())
      .then((resp: CountryEventType[]) => {
        this.setState(
          {
            tabs: resp
              .map(country => (
                {
                  link: `${WORLD_EVENTS}/${country.preLink}`,
                  label: I18n.t(`country.${country.preLink}`),
                }
              )),
          },
          this.redirectToFirstTab,
        );
      });
  };

  redirectToFirstTab = () => {
    if (!!this.state.tabs && this.state.tabs.length > 0) {
      this.props.history.push(this.state.tabs[0].link);
    }
  }

  componentDidMount() {
    if (this.state.tabs || this.state.tabs.isEmpty) {
      this.fetchTabsCountry();
    }
  }

  render() {
    const { tabs } = this.state;
    if (!tabs || tabs.length === 0) {
      return false;
    }
    return (
      <TabRouter
        className="events-header"
        titleClassName="events-subtitle"
        underline
        tabs={tabs}
        router={
          <Switch>
            {
              this.state.tabs.map(tab => (
                <Route
                  key={tab.label}
                  path={WORLD_DATA_EVENTS_COUNTRY}
                  render={() => (<EventTab />)}
                />
                ))
            }
          </Switch>
        }
      />
    );
  }
}

export default withRouter(EventPage);
